import { useSyncExternalStore } from "react";
import UploadTrayView from "../common/UploadTrayView";
import { cancelLibraryUpload, clearFinishedLibraryUploads, getLibraryUploads, subscribeLibraryUploads } from "../../services/libraryUploadService";

/**
 * The bottom-right progress tray for files being saved to Files (the same tray
 * the Investigations uploader uses). Mounted once in the Dashboard so uploads
 * keep showing as the officer moves between pages.
 */
const LibraryUploadTray: React.FC = () => {
  const items = useSyncExternalStore(subscribeLibraryUploads, getLibraryUploads);
  return (
    <UploadTrayView
      items={items.map((i) => ({ id: i.id, name: i.name, status: i.status, progress: i.progress, error: i.error, doneLabel: i.after }))}
      onClearFinished={clearFinishedLibraryUploads}
      activeHint="Keep this tab open until uploads finish. Transcription and reading continue on their own, and you can leave this page once they are uploaded."
      finishedHint="Everything is saved. You can leave this page."
      finishedVerb="Saved"
      onCancel={cancelLibraryUpload}
    />
  );
};

export default LibraryUploadTray;
